var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaxes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#9C1FE9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7H10C9.73478 7 9.48043 7.10536 9.29289 7.29289C9.10536 7.48043 9 7.73478 9 8V22C9 22.2652 9.10536 22.5196 9.29289 22.7071C9.48043 22.8946 9.73478 23 10 23H20C20.2652 23 20.5196 22.8946 20.7071 22.7071C20.8946 22.5196 21 22.2652 21 22V8C21 7.73478 20.8946 7.48043 20.7071 7.29289C20.5196 7.10536 20.2652 7 20 7ZM10 22V8H20V22H10Z",
    fill: "#9C1FE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H18.835V9H11.5C11.3674 9 11.2402 9.05268 11.1464 9.14645C11.0527 9.24022 11 9.36739 11 9.5V11.835H12V10Z",
    fill: "#9C1FE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H11V15H13V13H12V14Z",
    fill: "#9C1FE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H17V15H19V13H18V14Z",
    fill: "#9C1FE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14H14V15H16V13H15V14Z",
    fill: "#9C1FE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H11V18H13V16H12V17Z",
    fill: "#9C1FE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17H17V18H19V16H18V17Z",
    fill: "#9C1FE9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17H14V18H16V16H15V17Z",
    fill: "#9C1FE9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H11V21H13V19H12V20Z",
    fill: "#9C1FE9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H17V21H19V19H18V20Z",
    fill: "#9C1FE9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H14V21H16V19H15V20Z",
    fill: "#9C1FE9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxes);
export default __webpack_public_path__ + "static/media/taxes.d7da3f7e83d14653b5cea4a664ab7a90.svg";
export { ForwardRef as ReactComponent };